import { useEffect } from 'react'
import { useDataSource } from '@/src/renderer/lib/dataSource'
import { dispatchAppEvent } from '@/src/renderer/lib/events'

/**
 * **⇧↵ in der Schnelleingabe: Das Hauptfenster springt zur neuen Aufgabe** (Sven, 04.10.2026,
 * `.claude/tasks/quick-add-reveal.md`). Der Hauptprozess holt das Fenster nach vorn und hält die Kennung
 * bereit (`quickAddReveal.ts`). Abgeholt wird beim Start — das Fenster kann gerade dafür gebaut worden
 * sein — und auf `quick-add:reveal-ready`. Der Sprung ist der der Suche (`open-task`, `MainLayout`).
 */
export function useQuickAddReveal(): void {
  const source = useDataSource()

  useEffect(() => {
    const api = window.windowAPI
    if (!api?.takeQuickAddReveal) return
    let alive = true
    const take = async () => {
      const taskId = await api.takeQuickAddReveal?.()
      if (!alive || !taskId) return
      const task = await source.getTask(taskId)
      if (alive && task && !task.deletedAt) dispatchAppEvent('open-task', { task })
    }
    void take()
    const off = api.onWindowMessage?.('quick-add:reveal-ready', () => { void take() })
    return () => {
      alive = false
      off?.()
    }
  }, [source])
}
